module.exports = __webpack_public_path__ + "img/2054.77c730f4.jpg";